export default __webpack_public_path__ + "static/media/aws-glacier.707ad773.svg";